export const PARAPHEUR_COPY = {
  ctaSign: 'Signer',
  ctaValidate: 'Valider',
  ctaSend: 'Envoyer',
  fillAll: 'Tout remplir',
  addSigner: 'Ajouter un signataire',
  fallbackSigner: 'le signataire',
  confirmVisa: 'Confirmer le visa',
  confirmValidation: 'Confirmer la validation',
  reauthHint:
    'Saisissez votre mot de passe pour signer ce document. Une session déjà ouverte ne suffit pas.',
  reauthHintValidation:
    'Saisissez votre mot de passe pour valider ce document. Une session déjà ouverte ne suffit pas.',
  passwordRequired: 'Mot de passe requis pour signer',
  needBoxes: 'Posez au moins une case de paraphe avant de signer',
  fillRemaining: 'Remplissez toutes les cases (ou renvoyez le document)',
  thenFillAndSign: 'Ensuite : Tout remplir, puis Signer.',
  reviserBanner:
    'Un signataire a renvoyé le PDF. Remplacez-le, reposez les cases, puis renvoyez aux mêmes signataires.',
  cannotSignNoBoxes: 'L’initiateur n’a pas encore posé les cases. Impossible de signer.',
  dispatchHint:
    'Posez au moins une case Paraphe ou Signature, puis Envoyer. Les signataires ne sont prévenus qu’après.',
  needBoxesToSend: 'Posez au moins une case avant d’envoyer',
  toolParaphe: 'Paraphe',
  toolSignature: 'Signature',
  placeHint:
    'Choisissez Paraphe ou Signature, cliquez pour poser, glissez pour déplacer. Croix rouge = retirer. Enregistrement immédiat.',
} as const;

export function fillAndSignHint(waitingName: string, isCurrentSigner: boolean): string {
  if (isCurrentSigner) return PARAPHEUR_COPY.thenFillAndSign;
  return `Tout remplir et Signer s’affichent pour ${waitingName} (signataire actuel), pas sur ce compte.`;
}
